import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../../components/Simple/SMCButton';
import {SMCRadioGroup, SMCRadio} from '../../../components/Simple/SMCRadio';
import SMCLabel from '../../../components/Simple/SMCLabel';
import Indentation from '../../../components/Simple/Indentation';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function FirmwareWizardChoose({
    onCancel,
    setWizardStep,
}) {
    const { t } = useTranslation();

    const [wizardType, setWizardType] = useState('GA');
    
    const nextButtonFunction = () => {
        setWizardStep(wizardType);
    }

    return (
        <>
        <SMCModalBody>
            <Indentation>
                <SMCLabel bold fontSize="16px">{t('SMC_FIRMWARE_TYPE_TITLE')}</SMCLabel>
                <SMCLabel>{t('SMC_FIRMWARE_TYPE_TEXT')}</SMCLabel>
                <Indentation>
                    <SMCRadioGroup value={wizardType} onChange={e => setWizardType(e.target.value)}>
                        <SMCRadio value="GA" label={t('SMC_FIRMWARE_TYPE_PUBLIC_DESCRIPTION')} />
                        <SMCRadio value="HF" label={t('SMC_FIRMWARE_TYPE_PRIVATE_DESCRIPTION')} />
                    </SMCRadioGroup>
                </Indentation>
            </Indentation>
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={nextButtonFunction} style={{ marginRight: 5 }}>
                {t('SMC_GEN_WIZNEXT')}
                <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    );
}

export default FirmwareWizardChoose;